import React, {
    useEffect,
    useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import { coachingAPI } from 'api/coachingAPI';
import SearchIcon from 'assets/images/icon/SearchIcon';
import { cloneDeep } from 'lodash';
import { useNavigate } from 'react-router-dom';
import ReactSlider from 'react-slider';
import { useRecoilValue } from 'recoil';
import {RequestedData, userInfo} from 'state';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import {
    DropdownMenu,
    Overlay,
    Pagenation,
} from 'view/components';
import { CheckBox } from 'view/components/common/CheckBox';
import CreatePopup from 'view/pages/Coaching/components/CreatePopup';
import RequestPopup from 'view/pages/Coaching/components/RequestPopup';
import ListItem from "../components/ListItem";
import {liveAPI} from "../../../../api/liveAPI";
import CompletedPopup from "../components/CompletedPopup";
import {SucPopup} from "../../../../styled/StyledComponent";
import EmptyBox from "../../../components/common/EmptyBox";
import SearchInputItem from "../../../components/common/SearchInputItem";

const Requested = (props) => {
    const navigate = useNavigate();
    const [popup, setPopup] = useState(false);
    const reqData = useRecoilValue(RequestedData)
    const [list, setList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [coachingTitle, setCoachingTitle] = useState("")
    const [selectClass, setSelectClass] = useState(null);
    const [completedPopup, setCompletedPopup] = useState(false);
    const [sucAlert, setSucAlert] = useState(false);
    const [completed, setCompleted] = useState(true);
    const [received, setRceived] = useState(true);
    const [indexValue, setIndexValue] = useState({
        i: 0,
        v: 5,
    });
    const [pageInfo, setPageInfo] = useState({
        totalPages: 0,
        number: 0,
        size: 5,
    });
    const user = useRecoilValue(userInfo);
    const getReqList = () => {
        liveAPI.getRequestData({
            params:{
                coachingStatus:"NEW"
            }
        })
            .then(res => {
                console.log("@res",res);
                setList(cloneDeep(res?.data?.content))
            })
    };
    const getCoachingList = async () => {
        const result = await coachingAPI
            .getCoachingRequest({
                params: {
                    isNew:true,
                    // isReceived: received === true && completed === true ? "" : received,
                    // isCompleted: received === true && completed === true ? "" : !received,
                    // paged: true,
                    // page: pageNumber,
                    size: 105,
                    // gradeFrom:0,
                    // gradeTo:indexValue.v
                },
            })
            .then((res) => {
                console.log("coa data", res?.content);
                setList(cloneDeep(res?.content));
                // setPageInfo({
                //     totalPages: res?.totalPages,
                //     number: res?.number,
                //     size: res?.size,
                // });
            });
    };

    const getClassItems = () => {
        const c = cloneDeep(classList);
        const arr = c
            ?.map((item) => {
                return {
                    ...item,
                    dropdownItem: item?.classTitle || "",
                };
            })
            .filter((filterItem) => {
                return filterItem?.progress === "PUBLISHED";
            });
        return arr || [];
    };

    const onClickDropdown = (item: any, key: string, index, obj) => {
        let selectItem;
        console.log("obj", obj);
        if (!isEmpty(obj)) {
            const copy = cloneDeep(obj);
            delete copy.dropdownItem;
            selectItem = copy;
        } else {
            selectItem = item;
        }
        console.log("selectItem", selectItem);
        setSelectClass(cloneDeep(selectItem));
    };

    const createCoaching = async () => {
        coachingAPI.createCoaching({
            params:{
                classesId:selectClass?.id,
                title:coachingTitle
            }
        })
            .then(res => {
                if(res?.success === true && !isEmpty(res?.data?.id)){
                    navigate("/create_coaching/details",{
                        state:{
                            createId:res?.data?.id
                        }
                    })
                }
            })
    };

    console.log('selectClass', selectClass)

    const onClickGetData = (item) => {
        setSelectedData(cloneDeep(item));
        setCompletedPopup(true)
    };

    const onClickMovePage = (isNext) => {
        const c = cloneDeep(pageInfo);
        if (isNext) {
            if (pageInfo?.number + 1 === pageInfo?.totalPages) return;
            c.number = c.number + 1;
        } else {
            if (pageInfo?.number === 0) return;
            c.number = c.number - 1;
        }
        setPageInfo(c);
    };

    // useEffect(() => {
    //     getCoachingList();
    // }, []);

    // useEffect(() => {
    //     getCoachingList(pageInfo?.number);
    // }, [pageInfo.number]);

    // useEffect(() => {
    //     getCoachingList(0);
    // }, [indexValue?.v]);

    // useEffect(() => {
    //     getCoachingList(0);
    // }, [selectClass?.id]);

    // useEffect(() => {
    //     getClassItem();
    // }, []);

    useEffect(() => {
        getReqList();
    }, []);

    console.log("list",list);
    console.log("@selectedData",selectedData);

    return (
        <Container>
            {
                sucAlert &&
                <SucPopup style={{top: "8%", position: "fixed"}}>
                    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M16.9684 5.03712C15.0479 4.18139 12.9023 3.9694 10.8514 4.43276C8.80063 4.89611 6.95453 6.00999 5.58849 7.60826C4.22244 9.20653 3.40964 11.2036 3.2713 13.3015C3.13296 15.3995 3.6765 17.486 4.82085 19.2498C5.9652 21.0136 7.64905 22.3602 9.62127 23.0888C11.5935 23.8175 13.7484 23.8891 15.7646 23.2929C17.7809 22.6968 19.5504 21.4649 20.8093 19.7809C22.0682 18.0969 22.749 16.0511 22.7502 13.9486V12.9526C22.7502 12.3543 23.2352 11.8692 23.8335 11.8692C24.4318 11.8692 24.9168 12.3543 24.9168 12.9526V13.9492C24.9154 16.519 24.0833 19.02 22.5446 21.0782C21.006 23.1364 18.8432 24.6421 16.379 25.3707C13.9147 26.0993 11.2809 26.0118 8.87041 25.1212C6.45992 24.2307 4.40188 22.5848 3.00322 20.429C1.60457 18.2733 0.940247 15.7231 1.10933 13.159C1.27841 10.5948 2.27183 8.15398 3.94145 6.20053C5.61106 4.24709 7.8674 2.88569 10.374 2.31936C12.8805 1.75304 15.503 2.01214 17.8503 3.05802C18.3968 3.30153 18.6424 3.94197 18.3989 4.48849C18.1554 5.035 17.5149 5.28063 16.9684 5.03712Z"
                              fill="#333333"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M24.5988 4.51614C25.0221 4.93899 25.0224 5.62492 24.5996 6.0482L13.7663 16.8924C13.5631 17.0957 13.2875 17.21 13.0001 17.2101C12.7127 17.2101 12.437 17.096 12.2338 16.8928L8.9838 13.6428C8.56074 13.2197 8.56074 12.5338 8.9838 12.1107C9.40687 11.6876 10.0928 11.6876 10.5159 12.1107L12.9995 14.5943L23.0668 4.5169C23.4896 4.09362 24.1755 4.09328 24.5988 4.51614Z"
                              fill="#333333"/>
                    </svg>
                </SucPopup>
            }
            {popup && (
                <Overlay filter={true}>
                    <RequestPopup data={selectedData} onClickPopup={() => {

                        getCoachingList();
                        setPopup(v => !v);
                    }}/>
                </Overlay>
            )}
            {
                completedPopup && !isEmpty(selectedData) &&
                <Overlay filter={true}>
                    <CompletedPopup data={selectedData}
                                    onClickGetList={() => {
                                        getReqList();
                                    }}
                                    onClickPopup={() => {
                                        setSucAlert(true)
                                        setTimeout(()=>{
                                            setSucAlert(false)
                                        },1500)
                                        setCompletedPopup(false)
                                    }}/>
                </Overlay>
            }
            <ContentsInner>
                <Status>
                </Status>
                <SearchArea style={{marginBottom: 15}}>
                    <DropDownArea style={{width: "70%"}}>
                        <p>Check the coaching sessions that you have completed or declined</p>
                    </DropDownArea>
                    <SearchInputItem/>
                </SearchArea>
                <Wrap>
                    {
                        isEmpty(list) ?
                            <EmptyBox url={"/images/nothing.png"} />
                            :
                        list?.map((item, index)=>{
                            return(<ListItem
                                onClickGetData={onClickGetData}
                                data={item}></ListItem>)
                        })
                    }
                </Wrap>

            </ContentsInner>
            <Pagenation
                totalPage={pageInfo?.totalPages}
                onClickMove={(isNext) => {
                    onClickMovePage(isNext);
                }}
                size={pageInfo?.size}
                pageNumber={pageInfo?.number}
            />
        </Container>
    );
};
export default Requested;

const Container = styled.div`
    height: 100%;
    position: relative;
`;

const ContentsInner = styled.div`
    padding: 20px;
    overflow: hidden;
    position: relative;
    min-height: 550px;
    height: 100%;
`;
const Status = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const Wrap = styled.div`
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    
    overflow-y: auto;
    

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        width: 0;
        background-color: transparent;
    }
`;

const StatusCheck = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    p {
        margin-right: 15px;
        font-weight: 700;
        color: "#333";
        font-size: 18px;
    }
`;
const SearchArea = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 30px;
`;
const DropDownArea = styled.div`
    display: flex;
    width: 50%;
    p{
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        color: rgba(51, 51, 51, 1);
    }
`;

const DropDownWrap = styled.div`
    width: 100%;
    margin-right: 15px;
`;
const CheckItem = styled.div`
    span {
        margin-left: 5px;
        font-weight: 400;
        font-size: 18px;
    }
    margin-right: 15px;
    display: flex;
    align-items: center;
`;
const Slider = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    h5 {
        font-weight: 700;
        font-size: 18px;
        transform: translate(-20px, -7px);
    }
`;
const IndexItems = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 6px 0 6px;
    margin-top: 16px;
    span {
        text-align: center;
        display: flex;
        font-weight: 400;
        font-size: 14px;
        display: flex;
        justify-content: center;
    }
`;
const SliderWrap = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;

    .horizontal-slider {
        display: flex;
        align-items: center;

        .active {
            width: 16px;
            height: 16px;
            border: solid 1px red;
            background: red;
        }
        span {
            &:nth-child(1) {
                background: #fff;
            }
        }
        .mark {
            height: 16px;
            width: 16px;
            border-radius: 50%;
            background: #333;
            display: flex;
            align-items: center;
            justify-content: center;

            .indexItem {
                transform: translateY(10px);
            }
            &:first-of-type {
                background: #fff;
                border: solid 2px #333;
            }
            &:last-of-type {
                background: #fff;
                border: solid 2px #333;
            }
        }
        .track {
            height: 8px;
            border-radius: 6px;
            background: #3333331a;
        }
        .track-0 {
            background: #333333;
        }
        .thumb {
            border-radius: 50%;
            height: 16px;
            width: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #111;
        }
    }
`;
